import ProductMediaCover from "./product-media-cover";

export default ProductMediaCover;